import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { environment } from "environment";
import { getToken } from "helpers";

interface City {
  id: number;
  city: string;
  country: string;
  iso_2_code: string;
  alphabet: string;
}

interface CitiesResponse {
  data: City[];
}

interface ListMunicipalityOptions {
  page?: number;
  pageSize?: number;
  search?: string;
  sort?: string;
  order?: "asc" | "desc";
  lang: "MK" | "EN" | "AL";
}

export const cityApi = createApi({
  reducerPath: "cityApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.dev.baseUrl}/catalog/city/manage/`,
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set("authorization-token", token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCities: builder.query<CitiesResponse, ListMunicipalityOptions>({
      query: (options) => {
        const { page, pageSize, search, sort, order, lang } = options;
        return {
          url: "list",
          params: {
            lang,
            page,
            pageSize,
            search,
            sort,
            order,
          },
        };
      },
      transformResponse: (response: CitiesResponse) => response,
      transformErrorResponse: (error: any) => error.data?.apierror || error,
    }),
  }),
});

export const { useGetCitiesQuery, useLazyGetCitiesQuery } = cityApi;
